// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import CSS
import "../css/index.css";

// Import JS
import initHeaderMenu, { syncSiteHeaderOffset } from "./menuOpen";
import infiniteScroll from "./infiniteScroll";
import initAccordion from "./accordion"
import initGallery from "./initGallery";
import initAllStories from "./allStories";
import initHomepageRefresh from "./homepageRefresh";
import initAboutDev from "./aboutDev";
import initPressDev from "./pressDev";
import initTeamDev from "./teamDev";
import initDonateModal from "./donateModal";
import initEvents from "./events";
import initNewsletters from "./newsletters";
import initEditions from "./editions";
import initMultimedia from "./multimedia";
import initTopics from "./topics";
import initTagArchive from "./tagArchive";
import initJournalism from "./journalism";
import initArticleSystem from "./articleSystem";
import initCommunity from "./community";
import initLandingHeroSticky from "./landingHeroSticky";
import initAuthorDisplayNames from "./authorDisplayName";
import initSpeakersBureau from "./speakersBureau";
import initFooterNav from "./footerNav";
import initNativeNewsletterForms from "./nativeNewsletterForms";


// Call the menu and infinite scroll functions
//menuOpen();
infiniteScroll();

// Original (edition)
window.initGallery = initGallery;
// Original (edition) — unchanged
initGallery({
  triggerSelector: "article.tag-hash-gallery",
  contentSelector: ".edition-content",
  insertSelector: ".gallery-placeholder"
});

// The bundle is deferred, so the article DOM is complete here. Process credit
// markers before DOMContentLoaded to prevent them flashing in the article body.
initArticleSystem();

document.addEventListener('DOMContentLoaded', () => {
  initAuthorDisplayNames();
  initHeaderMenu();
  initAccordion();
  infiniteScroll();
  initAllStories();
  initHomepageRefresh();
  initAboutDev();
  initPressDev();
  initTeamDev();
  initDonateModal();
  initEvents();
  initNewsletters();
  initEditions();
  initMultimedia();
  initTopics();
  initTagArchive();
  initJournalism();
  initArticleSystem();
  initCommunity();
  initLandingHeroSticky();
  initSpeakersBureau();
  initFooterNav();
  initNativeNewsletterForms();
});


// Open all external links in new tab
document.addEventListener('DOMContentLoaded', function() {
  const links = document.querySelectorAll('a');
  
  links.forEach(link => {
    if (link.hostname !== window.location.hostname) {
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
    }
  });
});

document.addEventListener("codex:content-appended", function (event) {
  const root = event.detail?.container?.parentElement || document;
  initAuthorDisplayNames(root);
  syncSiteHeaderOffset(document);
  initHeaderMenu(root);
  initAccordion(root);
  infiniteScroll(root);
  initAllStories(root);
  initHomepageRefresh(root);
  initAboutDev(root);
  initPressDev(root);
  initTeamDev(root);
  initDonateModal();
  initEvents(root);
  initNewsletters(root);
  initEditions(root);
  initMultimedia(root);
  initTopics(root);
  initTagArchive(root);
  initJournalism(root);
  initArticleSystem(root);
  initCommunity(root);
  initLandingHeroSticky(root);
  initSpeakersBureau(root);
  initFooterNav(root);
  initNativeNewsletterForms(root);
});

window.addEventListener('ghost:load', initDonateModal);
